var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.linked
    ? _c("div", { staticClass: "c-static-map" }, [
        _c("span", { staticClass: "t-visually-hidden" }, [
          _vm._v(_vm._s(_vm.description))
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "c-static-map__image",
          attrs: { src: _vm.url, alt: _vm.alt }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "margin-left": "5px",
              "margin-right": "5px",
              "z-index": "1",
              position: "absolute",
              left: "0px",
              bottom: "0px"
            }
          },
          [
            _c(
              "a",
              {
                staticStyle: {
                  position: "static",
                  overflow: "visible",
                  float: "none",
                  display: "inline"
                },
                attrs: {
                  target: "_blank",
                  rel: "noopener",
                  href: _vm.mapLink + _vm.linkHref,
                  title: "Visa på Google Maps"
                }
              },
              [_vm._m(0)]
            )
          ]
        )
      ])
    : _c("div", { staticClass: "c-static-map" }, [
        _c("img", {
          staticClass: "c-static-map__image",
          attrs: { src: _vm.url, alt: _vm.alt }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "margin-left": "5px",
              "margin-right": "5px",
              "z-index": "1",
              position: "absolute",
              left: "0px",
              bottom: "0px"
            }
          },
          [
            _c(
              "a",
              {
                staticStyle: {
                  position: "static",
                  overflow: "visible",
                  float: "none",
                  display: "inline"
                },
                attrs: {
                  target: "_blank",
                  rel: "noopener",
                  href: _vm.mapLink + _vm.linkHref,
                  title: "Visa på Google Maps"
                }
              },
              [_vm._m(1)]
            )
          ]
        )
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { width: "66px", height: "26px", cursor: "pointer" } },
      [
        _c("img", {
          staticStyle: {
            position: "absolute",
            left: "0px",
            top: "0px",
            width: "66px",
            height: "26px",
            "user-select": "none",
            border: "0px",
            padding: "0px",
            margin: "0px"
          },
          attrs: {
            alt: "",
            src:
              "https://maps.gstatic.com/mapfiles/api-3/images/google4_hdpi.png",
            draggable: "false"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { width: "66px", height: "26px", cursor: "pointer" } },
      [
        _c("img", {
          staticStyle: {
            position: "absolute",
            left: "0px",
            top: "0px",
            width: "66px",
            height: "26px",
            "user-select": "none",
            border: "0px",
            padding: "0px",
            margin: "0px"
          },
          attrs: {
            alt: "",
            src:
              "https://maps.gstatic.com/mapfiles/api-3/images/google4_hdpi.png",
            draggable: "false"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }